module.exports = __webpack_public_path__ + "fonts/iconfont.33b81b5.woff2";